module.exports = __webpack_public_path__ + "static/media/IMG_3061.66a997ba.JPG";